// Generated code for Big.Domain.Enums.ProfessionalPositionSpecialCategoryType.
// Edit _Enum.tst to change the generated output.

export enum ProfessionalPositionSpecialCategoryType {
    unknown = 0,
    equivalentWork = 1,
    managerialPosition = 2
}
(ProfessionalPositionSpecialCategoryType as any).name = 'ProfessionalPositionSpecialCategoryType';
